import HomeOutlineSeven from '@assets/icons/home-outline-seven.svg'
import { Icon } from './Icon'

export const HomeOutlineSevenIcon = Icon(HomeOutlineSeven)
